import { graphql, type HeadProps, type PageProps } from 'gatsby'
import React from 'react'

import Cards from '@/components/card/cards'
import Header from '@/components/header/header'
import Pagination from '@/components/pagination/pagination'
import Seo from '@/components/seo/seo'
import Layout from '@/layouts/layout'

type DataProps = {
  datoCmsPctInternalPage: Queries.ProjectsQuery['datoCmsPctInternalPage']
  allDatoCmsPctProject: Queries.ProjectsQuery['allDatoCmsPctProject']
}

type PageContextProps = {
  limit: number
  skip: number
  numPages: number
  currentPage: number
  totalItems: number
}

export const Head: React.FC<HeadProps<DataProps, PageContextProps>> = ({
  data: { datoCmsPctInternalPage },
  location,
  pageContext: { currentPage }
}) => {
  return (
    <Seo
      seo={datoCmsPctInternalPage?.seoMetaTags}
      location={location}
      title={`${datoCmsPctInternalPage?.externalName}${
        currentPage > 1 ? ` (${currentPage})` : ''
      }`}
    />
  )
}

const Projects: React.FC<PageProps<DataProps, PageContextProps>> = ({
  pageContext,
  data: { datoCmsPctInternalPage, allDatoCmsPctProject },
  location
}) => {
  if (!datoCmsPctInternalPage) {
    return <></>
  }
  const { numPages, currentPage, totalItems } = pageContext
  return (
    <Layout location={location}>
      <Header
        title={datoCmsPctInternalPage.externalName}
        subtitle={datoCmsPctInternalPage.headline}
      />
      <Cards items={allDatoCmsPctProject.nodes} numberTotal={totalItems} />
      <Pagination
        currentPage={currentPage}
        numPages={numPages}
        basePath={`/${datoCmsPctInternalPage.slug}/`}
      />
    </Layout>
  )
}

export default Projects

export const query = graphql`
  query Projects($id: String = "", $skip: Int!, $limit: Int!) {
    datoCmsPctInternalPage(id: { eq: $id }) {
      ...PctInternalPageDetail
    }
    allDatoCmsPctProject(
      limit: $limit
      skip: $skip
      sort: { meta: { firstPublishedAt: DESC } }
    ) {
      nodes {
        ...PctProjectCard
      }
    }
  }
`
